// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopGooglePayControllerGetGooglePayEchoData } from './EshopGooglePayControllerGetGooglePayEchoData.gen';
import type { EshopGooglePayControllerGetGooglePayEchoErrors } from './EshopGooglePayControllerGetGooglePayEchoErrors.gen';
import type { EshopGooglePayControllerGetGooglePayEchoResponses } from './EshopGooglePayControllerGetGooglePayEchoResponses.gen';
import type { EshopGooglePayControllerInitGooglePayPaymentData } from './EshopGooglePayControllerInitGooglePayPaymentData.gen';
import type { EshopGooglePayControllerInitGooglePayPaymentErrors } from './EshopGooglePayControllerInitGooglePayPaymentErrors.gen';
import type { EshopGooglePayControllerInitGooglePayPaymentResponses } from './EshopGooglePayControllerInitGooglePayPaymentResponses.gen';
import type { Options } from './Options.gen';

export class EshopGooglePayController {
    /**
     * Returns Google Pay configuration parameters required for client-side initialization.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **GOOGLE_PAY_ECHO_ERROR** - Error from payment gateway echo.
     */
    public static getGooglePayEcho<ThrowOnError extends boolean = false>(options?: Options<EshopGooglePayControllerGetGooglePayEchoData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopGooglePayControllerGetGooglePayEchoResponses, EshopGooglePayControllerGetGooglePayEchoErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/payments/google-pay/echo',
            ...options
        });
    }
    
    /**
     * Initializes a new Google Pay payment session with the payment gateway.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **ORDER_USER_MISMATCH** - The order and logged user doesn't match.
     */
    public static initGooglePayPayment<ThrowOnError extends boolean = false>(options: Options<EshopGooglePayControllerInitGooglePayPaymentData, ThrowOnError>) {
        return (options.client ?? client).post<EshopGooglePayControllerInitGooglePayPaymentResponses, EshopGooglePayControllerInitGooglePayPaymentErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/payments/google-pay/init',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
